// src/pages/Terms.jsx
import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

export const Terms = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTerms = async () => {
      try {
        const settingsDoc = await getDoc(doc(db, "settings", "site"));
        if (settingsDoc.exists() && settingsDoc.data().terms) {
          setContent(settingsDoc.data().terms);
        } else {
          setContent(getDefaultTerms());
        }
      } catch (error) {
        console.error("Błąd ładowania regulaminu:", error);
        setContent(getDefaultTerms());
      } finally {
        setLoading(false);
      }
    };
    loadTerms();
  }, []);

  const getDefaultTerms = () => `
**§1 Postanowienia ogólne**

Motoradar24 to platforma służąca do wymiany informacji o pojazdach obserwowanych przez użytkowników.

**§2 Zasady korzystania**

1. Użytkownicy zobowiązani są do publikowania prawdziwych informacji
2. Zabrania się umieszczania treści obraźliwych lub niezgodnych z prawem
3. Administrator zastrzega sobie prawo do moderacji treści

**§3 Odpowiedzialność**

Platforma nie ponosi odpowiedzialności za działania użytkowników ani za skutki wykorzystania udostępnionych informacji.
  `.trim();

  const renderContent = (text) => {
    return text
      .split('\n')
      .map((line, i) => {
        line = line.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
        line = line.replace(/\*(.+?)\*/g, '<em>$1</em>');
        return <p key={i} dangerouslySetInnerHTML={{ __html: line || '<br/>' }} className="mb-2" />;
      });
  };

  if (loading) {
    return <div className="p-12 text-center text-gray-500">Ładowanie...</div>;
  }

  return (
    <div className="max-w-3xl mx-auto p-4 pb-32">
      <h1 className="text-3xl font-bold mb-6">Regulamin CarWatch</h1>
      <div className="bg-white rounded-xl border border-gray-200 p-6 text-sm text-gray-700 leading-relaxed">
        {renderContent(content)}
        <p className="text-xs text-gray-500 mt-8 border-t pt-4">
          Ostatnia aktualizacja: {new Date().toLocaleDateString('pl-PL')}
        </p>
      </div>
    </div>
  );
};